import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

import { DragHandlerParams, MoveService, Position } from './drag.models'

const DEFAULT_PADDING: Position = { top: 0, right: 0, bottom: 0, left: 0 }

const DEFAULT_ANIMATION = '0.35s ease-in-out'

@Injectable({
  providedIn: 'root',
})
export class MagneticMoveService implements MoveService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  onDragMove({ element, toPosition: { x, y } }: DragHandlerParams): Position {
    const newPosition: Position = {}
    const { clientHeight: viewportHeight, clientWidth: viewportWidth } = this.document.body
    const { offsetHeight: elemHeight, offsetWidth: elemWidth } = element

    if (x < viewportWidth / 2) {
      newPosition.left = x
    } else {
      newPosition.right = viewportWidth - x - elemWidth
    }

    if (y < viewportHeight / 2) {
      newPosition.top = y
    } else {
      newPosition.bottom = viewportHeight - y - elemHeight
    }

    element.style.transition = null

    return newPosition
  }

  onDragEnd({
    element,
    toPosition,
    padding,
    animation = DEFAULT_ANIMATION,
  }: DragHandlerParams): Position {
    element.style.transition = animation

    return this.calculateElementNewPosition({ element, toPosition, padding })
  }

  calculateElementNewPosition({
    element,
    toPosition: { x, y },
    padding = DEFAULT_PADDING,
  }: DragHandlerParams): Position {
    const newPosition: Position = {}
    const { clientHeight: viewportHeight, clientWidth: viewportWidth } = this.document.body
    const { offsetHeight: elemHeight } = element

    if (x < viewportWidth / 2) {
      newPosition.left = padding.left
    } else {
      newPosition.right = padding.right
    }

    if (padding.top && y < padding.top) {
      newPosition.top = padding.top
    } else if (padding.bottom && y > viewportHeight - padding.bottom) {
      newPosition.bottom = padding.bottom
    } else if (y > viewportHeight / 2) {
      newPosition.bottom = viewportHeight - y - elemHeight
    } else {
      newPosition.top = y
    }

    return newPosition
  }
}
